export default __webpack_public_path__ + "static/media/path4.088145b5.svg";